module.exports = __webpack_public_path__ + "static/pattern4-ed93ac745f63b1ded3826181e3dc05b2.png";